import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { ButtonStylingModel } from '../button/button-styling.model';
export class FormQuestionStylingModel extends CoreStylingModel {
/**
 * Styling for the form submit section
 */
errorMessage?: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function FormQuestionStylingModel_tsickle_Closure_declarations() {
/**
 * Styling for the form submit section
 * @type {?}
 */
FormQuestionStylingModel.prototype.errorMessage;
}

